import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  background-color: #f9f9f9;
`;

export const Content = styled.main`
  flex-grow: 1;
  padding: 20px 30px;
`;
